import { toast } from "react-toastify";
import { _NoteImp, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { useEffect } from "react";
import "./NotesImp.css"

interface Props {
    Action: any;
}

export const NotesImp = ({ Action }: Props) => {

    const { instance, bean, setBean, setLista, lista } = useDataBean(_NoteImp);

    useEffect(() => {
        if (Action.IDProcedureImp) {
            getNotes()
        }
        setBean({
            IDAction: Action.IDAction,
            IDProcedureImp: Action.IDProcedureImp,
            IDEmployee: _single.getAccountID(),
            Employee: _single.getAccount().EntityName,
        })
    }, [Action.IDProcedureImp])

    const getNotes = () => {
        const Props = {
            IDProcedureImp: Action.IDProcedureImp
        }
        instance.getNoteImpCatalogPorPropiedades(Props, null).then(
            (resp) => {
                console.log(resp)
                setLista(resp)
            }
        ).catch(
            err => {
                console.log(err)
                toast.error("No se pudo cargar la Información")
            }
        )
    }

    const addNote = () => {
        instance.updateNoteImp(bean).then(
            (resp) => {
                console.log(resp);
                setBean({ ...bean, "Message": "" });
                getNotes();
            }
        ).catch(
            err => {
                console.log(err)
                toast.error("No se pudo realizar la Acción")
            }
        )
    }



    return (
        <div className="row" style={{ maxHeight: `66vh`, overflow: "auto" }}>
            <div className="col-md-12" style={{ height: `${Action.IDAction ? "75%" : "100%"}`, overflow: "auto" }}>
                {Array.isArray(lista) && lista.length > 0 ? (
                    lista.map((Obs, index) => {
                        const Note = Obs.DataBeanProperties;
                        return (
                            <div className={`row d-flex ${Note.IDEmployee == _single.getAccountID() ? "justify-content-end" : "justify-content-start"}`} key={index}>
                                <div className={`message ${Note.IDEmployee == _single.getAccountID() ? "admin-message" : "user-message"}`}>
                                    {/* <button className={`delete-btn ${Note.IDEmployee == _single.getAccountID() ? "" : "d-none"}`} onClick={() => deleteNote(Note.IDNoteImp)}>x</button> */}
                                    <div className="col-12 py-2">
                                        <strong>{Note.Employee}:</strong>
                                    </div>
                                    <div className="col-md-12">
                                        <p>{Note.Message}</p>
                                    </div>
                                    <div className="col-12 py-2">
                                        <small>{Note.Since}</small>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <p>No hay notas asignadas</p>
                        </div>
                    </div>
                )}
            </div>
            {Action.IDAction &&
                <div className="col-md-12">
                    <hr />
                    <div className="input-group">
                        <textarea className="form-control" value={bean.Message} rows={4} onChange={(e) => { setBean({ ...bean, "Message": e.target.value }) }} style={{ resize: "none" }} />
                        <BasicButton eventClick={() => { addNote() }} icon="ri-edit-2-line" children={"Agregar nota"} />
                    </div>
                </div>
            }
        </div>
    )
}